const organizationGeneral = (organizationId: string) => `/app/organizations/${organizationId}/general`;
const organizationMembers = (organizationId: string) => `/app/organizations/${organizationId}/members`;
const organizationRoles = (organizationId: string) => `/app/organizations/${organizationId}/roles`;
const organizationInvites = (organizationId: string) => `/app/organizations/${organizationId}/invites`;
const organizationPricing = (organizationId: string) => `/app/organizations/${organizationId}/pricing`;
const organizationSettings = (organizationId: string) => `/app/organizations/${organizationId}/settings`;

const homePath = '/app/listings';
const onboardingPath = '/app/organizations';
const appraisalPath = '/appraisal';

// Detail pages for a listing
const integrationsPath = 'integrations';
const activityPath = 'activity';
const historyPath = 'history';
const notesPath = 'notes';
const vehicleInformationPath = 'vehicle-information';
const vehicleConditionPath = 'vehicle-condition';
const actionsPath = 'actions';

const listingDetailPaths = {
  actionsPath,
  activityPath,
  historyPath,
  notesPath,
  vehicleInformationPath,
  vehicleConditionPath,
  integrationsPath,
};

export {
  appraisalPath,
  homePath,
  listingDetailPaths,
  onboardingPath,
  organizationGeneral,
  organizationInvites,
  organizationMembers,
  organizationPricing,
  organizationRoles,
  organizationSettings,
};
